import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6'];

const CashMemoDirectDetails = ({ data }) => {
    if (!data || !data.summary) return null;

    const s = data.summary;

    const locationData = {
        labels: (data.by_location || []).map(l => l.location_name),
        datasets: [{
            label: 'Revenue (BHD)',
            data: (data.by_location || []).map(l => l.revenue),
            backgroundColor: COLORS,
            borderRadius: 4,
        }],
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Cash Memo Direct Details</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">CMD Count</small>
                            <strong>{s.total_count}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Revenue</small>
                            <strong>{s.total_revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Avg Value</small>
                            <strong>{s.avg_value?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Range</small>
                            <strong>{s.min_value?.toLocaleString(undefined, { minimumFractionDigits: 3 })} - {s.max_value?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                {data.by_location && data.by_location.length > 0 && (
                    <>
                        <Bar data={locationData} options={{
                            responsive: true,
                            indexAxis: 'y',
                            plugins: { legend: { display: false } },
                        }} />
                        <div className="table-responsive mt-3">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Location</th>
                                        <th className="text-end">Count</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-end">Avg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_location.map((l, i) => (
                                        <tr key={i}>
                                            <td>{l.location_name}</td>
                                            <td className="text-end">{l.count}</td>
                                            <td className="text-end">{l.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{l.avg_value?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CashMemoDirectDetails;
